import { InvoiceReminderSchedule, ReminderAnchor, ReminderDayRange } from "../../../domain/invoicing/settings/invoiceReminderSchedule"
import { addReminder, removeReminder, setAnchor, setAtTime, setDays, setEmailTemplateGuid, setEnabled } from "./invoiceReminderScheduleModel"

export type State = {
  serverSchedule: InvoiceReminderSchedule
  schedule: InvoiceReminderSchedule
}

export type Action =
  | { type: 'SERVER_SCHEDULE_LOADED', value: InvoiceReminderSchedule }
  | { type: 'ENABLED_CHANGED', value: boolean }
  | { type: 'DAYS_CHANGED', id: string, value: number }
  | { type: 'ANCHOR_CHANGED', id: string, value: ReminderAnchor }
  | { type: 'AT_TIME_CHANGED', id: string, value: string }
  | { type: 'EMAIL_TEMPLATE_CHANGED', id: string, value: string }
  | { type: 'REMINDER_ADDED', range: ReminderDayRange }
  | { type: 'REMINDER_REMOVED', id: string }

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SERVER_SCHEDULE_LOADED':
      return { serverSchedule: action.value, schedule: action.value }
    case 'ENABLED_CHANGED':
      return { ...state, schedule: setEnabled(state.schedule, action.value) }
    case 'DAYS_CHANGED':
      return { ...state, schedule: setDays(state.schedule, action.id, action.value) }
    case 'ANCHOR_CHANGED':
      return { ...state, schedule: setAnchor(state.schedule, action.id, action.value) }
    case 'AT_TIME_CHANGED':
      return { ...state, schedule: setAtTime(state.schedule, action.id, action.value) }
    case 'EMAIL_TEMPLATE_CHANGED':
      return { ...state, schedule: setEmailTemplateGuid(state.schedule, action.id, action.value) }
    case 'REMINDER_ADDED':
      return { ...state, schedule: addReminder(state.schedule, action.range) }
    case 'REMINDER_REMOVED':
      return { ...state, schedule: removeReminder(state.schedule, action.id) }
    default:
      return state
  }
}
